import { useEffect, useState } from "react";
import { filterConstants } from "../../constants";

import { invoiceStatus } from "../../enums";
import { useQueryString } from "../../hooks";
import {
  IInvoice,
  IQueryStringNavLinks,
  ITableHeader,
} from "../../interfaces-and-types";
import { invoicesData } from "../../test-data";
import { View } from "./View";

export interface IInvoiceViewProps {
  data: IInvoice[];
  headers: ITableHeader[];
  isLoading: boolean;
  isError: boolean;
  totalCount: number;
  queryStringTabs: IQueryStringNavLinks;

  // modals
  isCreateNewModalOpen: boolean;
  closeModal: () => void;

  // extra buttons
  onExport: () => void;
  openCreateNewModal: () => void;
}

export const Invoices = () => {
  const [isCreateNewModalOpen, setCreateNewModalOpen] = useState(false);
  const closeModal = () => {
    setCreateNewModalOpen(false);
  };

  const [isLoading, setisLoading] = useState(true);

  const query = useQueryString();
  const status = query.get(filterConstants.statusKey);

  useEffect(() => {
    setTimeout(() => setisLoading(false), 500);
  }, []);

  const headers: ITableHeader[] = [
    {
      key: "amount",
      header: "Amount",
    },
    {
      key: "status",
      header: "Status",
    },
    {
      key: "invoice_number",
      header: "Invoice Number",
    },
    {
      key: "customer",
      header: "Customer",
    },
    {
      key: "date",
      header: "Date Created",
    },
    {
      key: "date_due",
      header: "Due Date",
    },
    {
      key: "more",
      header: "",
    },
  ];

  const queryStringTabs: IQueryStringNavLinks = {
    query: filterConstants.statusKey,
    options: [
      {
        key: "All Invoices",
        value: "",
      },
      {
        key: "Outstanding",
        value: "outstanding",
      },
      {
        key: "Draft",
        value: "draft",
      },
      {
        key: "Paid",
        value: "paid",
      },
      {
        key: "Overdue",
        value: "overdue",
      },
    ],
  };

  const queryFilteredData = invoicesData.filter(
    (pd) => !status || status === "all" || invoiceStatus[pd.status] === status
  );

  const onExport = () => {
    // export data via api and download
    alert("exporting data...");
  };
  const openCreateNewModal = () => {
    // openModal
    setCreateNewModalOpen(true);
  };

  return (
    <View
      data={queryFilteredData}
      headers={headers}
      isLoading={isLoading}
      isError={false}
      totalCount={queryFilteredData.length}
      queryStringTabs={queryStringTabs}
      onExport={onExport}
      openCreateNewModal={openCreateNewModal}
      isCreateNewModalOpen={isCreateNewModalOpen}
      closeModal={closeModal}
    />
  );
};
